/* import __COLOCATED_TEMPLATE__ from './base.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();